import { FlexColumn, StyledBanner, StyledButton } from '@gorila-shared-ui/components';
import { getCurrentUser } from 'aws-amplify/auth';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useStyles } from '../../hooks/useStyles';
import { LoginContainer } from '../login/LoginContainer';
import { LoginForm } from '../login/LoginForm';
import { HeadTitle } from '../shared/HeadTitle';
import { StyledRouterLink } from '../ui/StyledRouterLink';

export function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const canSubmit = !!username && !!password;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { login } = useAuth();
  const { css, theme } = useStyles();

  useEffect(() => {
    const validateSession = async () => {
      try {
        const currentUser = await getCurrentUser();
        if (currentUser) navigate('/');
      } catch (err) {}
    };
    validateSession();
  });

  const handleLogin = async () => {
    if (!canSubmit) return;
    setLoading(true);
    const response = await login(username, password);
    if (response?.error) {
      setError(`${response.error}`);
    } else {
      navigate('/');
    }
    setLoading(false);
  };

  const onSubmit = () => {
    if (canSubmit) {
      handleLogin();
    }
  };

  return (
    <LoginContainer>
      <HeadTitle title="Iniciar sesión" />
      <FlexColumn centered>
        <LoginForm
          user={username}
          password={password}
          onChangeUser={setUsername}
          onChangePass={setPassword}
          onSubmit={onSubmit}
        />
        {error && (
          <StyledBanner
            title="*Error*"
            kind="negative"
            full
            action={{
              label: 'Label',
              onClick: () => {
                setError('');
              },
            }}
          >
            {error}
          </StyledBanner>
        )}
        <StyledButton
          full
          size="default"
          onClick={handleLogin}
          isLoading={loading}
        >
          Ingresar
        </StyledButton>
        <StyledRouterLink
          to="/forgotten-password"
          className={css({ marginTop: theme.sizing.scale600 })}
        >
          Olvidé mi contraseña
        </StyledRouterLink>
      </FlexColumn>
    </LoginContainer>
  );
}
